"use client";

import { useState } from "react";
import Image from "next/image";
import CaretDownIcon from "./images/caretdown.svg";
import CaretUpIcon from "./images/caretup.svg";

interface Props {
  collapsedTitle: string;
  expandedTitle: string;
  children: React.ReactNode;
}

export default function MobileCollapsibleSection({
  collapsedTitle,
  expandedTitle,
  children,
}: Props) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={isOpen ? "expanded" : ""}>
      <button
        className="mobileMoreInfoToggle"
        aria-label={isOpen ? expandedTitle : collapsedTitle}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="sectionTitle">
          <div className="imageWrapper">
            <Image
              src={isOpen ? CaretUpIcon : CaretDownIcon}
              alt=""
              width={16}
              height={16}
            />
          </div>
          <span>{isOpen ? expandedTitle : collapsedTitle}</span>
        </div>
      </button>
      {isOpen && <div>{children}</div>}
    </div>
  );
}
